import { AchMethodModel, PaymentMethodModel } from '../../customer/customer.model';

/**
 * The gateway `paymentAccount` for a one-time card or ACH entry — the JSON that is session-encrypted
 * into `encryptedPaymentAccount`. Shared by Collect Payment's one-time branches and Quick Pay, so the
 * two screens send the processor the same shape. ACH is told apart by the built method's tokenType.
 * `requireCVV` is the profile's setting (default true): off, or a blank CVV, sends `ignoreCVV`.
 */
export function buildOneTimePaymentAccount(
  payment: PaymentMethodModel | null | undefined,
  requireCVV = true
): Record<string, unknown> {
  if (payment?.tokenType === 'ACH') {
    const ach = payment as AchMethodModel;
    return {
      requestType: 'ACH',
      account: ach?.account || '',
      abaRoute: ach?.abaRoute || '',
      accountType: ach?.accountType || 'BUSINESS',
      accountHolderName: ach?.accountHolderName || undefined,
      accountHolderFirstName: ach?.accountHolderFirstName || undefined,
      accountHolderLastName: ach?.accountHolderLastName || undefined,
    };
  }
  const zipValue = payment?.zipCode || '';
  const streetValue = payment?.streetAddress || '';
  const cvvValue = payment?.cvv || '';
  const ignoreCVV = !requireCVV || cvvValue === '' ? true : undefined;
  return {
    requestType: 'CARD',
    account: payment?.account || '',
    cardHolderName: payment?.cardHolderName || '',
    expirationDate: payment?.expirationDate || '',
    cvv: ignoreCVV ? undefined : cvvValue,
    zipCode: zipValue,
    streetAddress: streetValue,
    ignoreStreet: streetValue === '' ? true : undefined,
    ignoreZip: zipValue === '' ? true : undefined,
    ignoreCVV: ignoreCVV,
  };
}
